import type { PropsWithChildren } from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export function DetailPanel({ open, onClose, title, subtitle, actions, children }: PropsWithChildren<Props>) {
  if (!open) return null;
  return (
    <aside className="dp" role="complementary">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
        <div>
          <div className="dp-title">{title}</div>
          {subtitle ? <div style={{ fontSize: 11, color: 'var(--muted)' }}>{subtitle}</div> : null}
        </div>
        <button className="close-btn" aria-label="Close" onClick={onClose}>×</button>
      </div>
      {children}
      {actions ? <div style={{ marginTop: 14, display: 'flex', gap: 6, flexWrap: 'wrap' }}>{actions}</div> : null}
    </aside>
  );
}
